import { Cashback } from '../Cashback'

const HomeLys = props => {
  return (
    <>
      <Cashback mdmClientNumber={props.mdmClientNumber} />
    </>
  )
}

export default HomeLys
